// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"578":"4131839e","646":"fdcb5ede"}[chunkId] + ".chunk.css";
};